import {useNavigate} from "react-router-dom";
import ContactPage from "./ContactPage";
const user = {
    name: "Chunhao Hsu",
    imageUrl: "https://i.imgur.com/J7E57j9.jpeg",
    imageSize: 500,
};
function MidSection(){
    const navigate = useNavigate();
    const handleContactClickToContact = () => {
        // 在此处理按钮点击事件，导航到联系页面
        navigate('/contact');
    };
    const handleContactClickToResume = () => {
        // 在此处理按钮点击事件，导航到联系页面
        navigate('/resume');
    }
    const handleContactClickToProjects = () => {
        // 在此处理按钮点击事件，导航到联系页面
        navigate('/projects');
    }
    return (
        <div className="header">
        <div className="container">
            <div className="row">
                <div className="column">
                    <div>
                        <img
                            className="avatar"
                            src={user.imageUrl}
                            alt={"Photo of " + user.name}
                            style={{
                                width: user.imageSize,
                                height: user.imageSize,
                                borderRadius: "50%",
                            }}
                        />
                    </div>
                </div>
                <div className="column">
                    <div style={{textAlign: "left"}}>
                        <h1 style={{fontSize: "100px", marginLeft: "0px"}}>Hello</h1>
                        <h2>A Bit About Me</h2>
                        <p>I was awarded my Master's in Software Development at the University of Utah.</p>
                        <p>I am eager to apply my technical skills and knowledge practically based on my</p>
                        <p>diverse background in software development and project management.</p>

                        <div className="button-container">
                            <button className="circle-button" onClick={handleContactClickToResume}>Resume</button>
                            <button className="circle-button" onClick={handleContactClickToProjects}>Projects</button>
                            <button className="circle-button" onClick={handleContactClickToContact}>Contact</button>
                        </div>


                    </div>


                </div>


            </div>
        </div>
        </div>

    );
}
export default MidSection;